import { differenceInYears } from 'date-fns'

export const parseOpenEMRDate = (date: string): Date | undefined => {
  const parsedDate = new Date(date)

  if (Number.isNaN(parsedDate.getTime())) {
    console.debug('Error parsing patient date of birth', date)
    return undefined
  }

  return parsedDate
}

export const calculateAge = (dob?: string): number | null => {
  if (dob === undefined) {
    return null
  }

  const date = parseOpenEMRDate(dob)

  if (!date) {
    return null
  }

  const age = differenceInYears(new Date(), date)
  return age
}
